import fetch from "../fetch";

export default ({ dealCode }) =>
  fetch({
    path: `/cmbs/deals/${dealCode}/borrowers`,
  });
